import { Event } from '../../index.js';
export class Shortcut extends Event.Dispatcher {
    static add(key, callback) {
        Shortcut.instance.add(key, callback);
    }
    constructor(options = {}) {
        super();
        this.keymap = {};
        this.attached = false;
        this.keysDown = {};
        this.options = {
            ignoreInputs: true,
        };
        Object.assign(this.options, options || {});
    }
    add(key, callback) {
        this.ensureSetup();
        this.keymap[key] = callback;
    }
    remove(key) {
        delete this.keymap[key];
    }
    ensureSetup() {
        if (this.attached) {
            return;
        }
        this.attached = true;
        document.addEventListener('keydown', this.Handle_OnKeyDown.bind(this));
        document.addEventListener('keyup', this.Handle_OnKeyUp.bind(this));
    }
    findMatch() {
        let keys = Object.keys(this.keymap);
        keys = keys.sort((a, b) => {
            var _a, _b;
            return (((_a = b.match(/\+/g)) === null || _a === void 0 ? void 0 : _a.length) || 0) - (((_b = a.match(/\+/g)) === null || _b === void 0 ? void 0 : _b.length) || 0);
        });
        return keys.find((key) => {
            const parsed = key.replace(/\s+/g, '').toLowerCase().split('+');
            return parsed.every((key) => {
                return this.keysDown[key.toLowerCase()];
            });
        });
    }
    normalize(key) {
        return key
            .toLowerCase()
            .trim()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace('arrow', '');
    }
    Handle_OnKeyDown(e) {
        const currentTarget = e.target;
        if (!(e instanceof KeyboardEvent)) {
            return;
        }
        if (this.options.ignoreInputs) {
            if (currentTarget.tagName === 'INPUT' || currentTarget.tagName === 'TEXTAREA') {
                return;
            }
        }
        const key = this.normalize(e.key);
        this.keysDown[key] = true;
        const match = this.findMatch() || '';
        const callback = this.keymap[match];
        if (!callback) {
            return;
        }
        this.trigger('shortcut:found', { match });
        callback();
    }
    Handle_OnKeyUp(e) {
        if (!(e instanceof KeyboardEvent)) {
            return;
        }
        const key = this.normalize(e.key);
        delete this.keysDown[key];
    }
}
Shortcut.instance = new Shortcut({
    ignoreInputs: true,
});
export class ShortcutSequencer extends Event.Dispatcher {
    static add(keys, callback) {
        ShortcutSequencer.instance.add(keys, callback);
    }
    static remove(keys) {
        ShortcutSequencer.instance.remove(keys);
    }
    constructor() {
        super();
        this.matches = [];
        this.sequences = {};
        this.shortcut = new Shortcut();
        this.shortcut.on('shortcut:found', this.Handle_OnShortcutFound.bind(this));
    }
    add(keys, callback) {
        const key = keys.join(',');
        keys.forEach((key) => {
            this.shortcut.add(key, () => { });
        });
        this.sequences[key] = callback;
    }
    remove(keys) {
        const key = keys.join(',');
        keys.forEach((key) => {
            this.shortcut.remove(key);
        });
        delete this.sequences[key];
    }
    async Handle_OnShortcutFound(e) {
        const match = e.data.match;
        this.matches.push(match);
        this.matches = this.matches.slice(-20);
        const sequence = Object.keys(this.sequences).find((sequence) => {
            const keys = sequence.split(',');
            const matches = this.matches.slice(-keys.length);
            return (matches.length >= keys.length &&
                matches.every((match, index) => {
                    return match === keys[index];
                }));
        });
        if (!sequence) {
            return;
        }
        const callback = this.sequences[sequence];
        if (!callback) {
            return;
        }
        callback();
    }
}
ShortcutSequencer.instance = new ShortcutSequencer();
//# sourceMappingURL=data:application/json;base64,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